/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_SubtitleInputs */

const en_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a PDF/DOCX and we'll extract everything automatically.`)
};

const de_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade ein PDF/DOCX hoch und wir extrahieren alles automatisch.`)
};

const fr_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge un PDF/DOCX et nous extrairons tout automatiquement.`)
};

const es_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suba un PDF/DOCX y extraeremos todo automáticamente.`)
};

const it_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un PDF/DOCX e noi estrarreremo automaticamente tutto.`)
};

const nl_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload een PDF/DOCX en we halen alles automatisch eruit.`)
};

const pl_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj PDF/DOCX i wyciągniemy wszystko automatycznie.`)
};

const fi_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa PDF/DOCX-tiedosto ja me uutamme kaikki automaattisesti.`)
};

const da_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload en PDF/DOCX, og vi vil ekstrahere alt automatisk.`)
};

const sv_onboarding_resume_subtitle = /** @type {(inputs: Onboarding_Resume_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp en PDF/DOCX och vi extraherar allt automatiskt.`)
};

/**
* | output |
* | --- |
* | "Upload a PDF/DOCX and we'll extract everything automatically." |
*
* @param {Onboarding_Resume_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_subtitle = /** @type {((inputs?: Onboarding_Resume_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_subtitle(inputs)
	if (locale === "fr") return fr_onboarding_resume_subtitle(inputs)
	if (locale === "es") return es_onboarding_resume_subtitle(inputs)
	if (locale === "it") return it_onboarding_resume_subtitle(inputs)
	if (locale === "nl") return nl_onboarding_resume_subtitle(inputs)
	if (locale === "pl") return pl_onboarding_resume_subtitle(inputs)
	if (locale === "fi") return fi_onboarding_resume_subtitle(inputs)
	if (locale === "da") return da_onboarding_resume_subtitle(inputs)
	if (locale === "sv") return sv_onboarding_resume_subtitle(inputs)
	return en_onboarding_resume_subtitle(inputs)
});